<div class="marketing-consent-container">
  <div class="title">
    <span class="casto-title">
      <span class="blue"
            [innerHTML]="'marketing-consent.title'|translate">
      </span>
    </span>
  </div>
  <div class="subtitle">
    <span [innerHTML]="'marketing-consent.subtitle'|translate"></span>
  </div>
  <div class="selectors" [formGroup]="marketingConsentFormGroup">
    <div class="selector">
      <p-inputSwitch formControlName="email" />
      <span class="label" [innerHTML]="'marketing-consent.mail'|translate"></span>
    </div>
    <div class="selector">
      <p-inputSwitch formControlName="sms" />
      <span class="label" [innerHTML]="'marketing-consent.sms'|translate"></span>
    </div>
    <div class="selector">
      <p-inputSwitch formControlName="phone" />
      <span class="label" [innerHTML]="'marketing-consent.phone'|translate"></span>
    </div>
    <div class="selector">
      <p-inputSwitch formControlName="post" />
      <span class="label" [innerHTML]="'marketing-consent.post'|translate"></span>
    </div>
  </div>
</div>
